var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Reservation"}},[_c('Load'),_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }